import { AbstractControl, AsyncValidatorFn, ValidationErrors } from "@angular/forms";
import { DashboardBuilderService } from "../dashboard-builder-service/dashboard-builder.service";
import { Observable, of } from "rxjs";
import { map } from "rxjs/operators";

export class DashboardnameValidator {
    static createValidator(dashboardBuilderService:DashboardBuilderService ,dashboardBuilderVarService:any): AsyncValidatorFn {
        return (control: AbstractControl): Observable<ValidationErrors> => {
            if(dashboardBuilderVarService.dashboard_builder_mode == 'edit'){
                return of(null);
            } else {
                return dashboardBuilderService.checkDashboardnameExists(control.value)
                .pipe(
                    map((result: any) =>{
                        if(result.dashboard_name_exist){ 
                            return {dashboardNameAlreadyExists: true }
                        }else{
                        return null
                        } 
                    })
                );
            }
        
        };
    }
}